export default function Params({ params }) {
  const { qty, size } = params;
  return (
    <div className="ob-params">
      <p>
        <img
          style={{ height: "24px", width: "24px" }}
          src={process.env.PUBLIC_URL + "/capacity.svg"}
          alt="Capacity"
        />
        {qty}
      </p>
      <p>
        <img
          style={{ height: "39.6px", width: "39.6px" }}
          src={process.env.PUBLIC_URL + "/circulation.svg"}
          alt="Circulation"
        />
        {size}
      </p>
    </div>
  );
}
